export const VALIDATION_GATE_QUERY_KEY = ['validation-gate', 'me'] as const;

export const CROSS_VALIDATION_ERROR_CODE = 'CROSS_VALIDATION_REQUIRED';

export const FALLBACK_BLOCK_THRESHOLD = 50;
export const FALLBACK_WARNING_THRESHOLD = 40;
export const FALLBACK_VALIDATIONS_REQUIRED = 100;
